import axios from 'axios';

// Separate axios instance for the customer portal — its own token,
// its own login redirect, fully isolated from staff auth.
const clientApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001')
});

clientApi.interceptors.request.use(config => {
  const token = localStorage.getItem('cw_client_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

clientApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/client')) {
      localStorage.removeItem('cw_client_token');
      localStorage.removeItem('cw_client_customer');
      window.location.href = '/client/login';
    }
    return Promise.reject(err);
  }
);

export default clientApi;
